import React from "react";

import {
  AnyProgressBarWidget,
  DiscountMessageBoxWidget,
  DiscountQuantityWidget,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { ConfigType, WidgetDrawerProps } from "../../../types/widgets";
import { IgDiscountMessageBox } from "../DiscountMessageBoxWidgetsTab/IgDiscountMessageBox";
import { IgDiscountProgressBar } from "../DiscountProgressBarWidgetsTab/IgDiscountProgressBar";
import { IgDiscountQuantityWidget } from "../DiscountQuantityWidgetsTab/IgDiscountQuantityWidget";
import { IgShippingProgressBar } from "../ShippingProgressBarWidgetsTab/IgShippingProgressBar";

type PreviewSettingsProps = WidgetDrawerProps & { configType: ConfigType };
export const PreviewSettings = ({
  widget,
  widgetType,
  configType,
}: PreviewSettingsProps) => {
  if (widgetType === "quantityButtons") {
    return (
      <Grid item container direction={"row"} justifyContent={"center"}>
        <IgDiscountQuantityWidget
          configType={configType}
          quantityWidget={widget as DiscountQuantityWidget}
        />
      </Grid>
    );
  }

  if (widgetType === "discountProgressBar") {
    return (
      <Grid
        item
        container
        direction={"column"}
        justifyContent={"flex-start"}
        rowSpacing={2}
      >
        <IgDiscountProgressBar
          threshold={3}
          configType={configType}
          progressBarWidget={widget as AnyProgressBarWidget}
        />
      </Grid>
    );
  }

  if (widgetType === "shippingProgressBar") {
    return (
      <Grid
        item
        container
        direction={"column"}
        justifyContent={"flex-start"}
        rowSpacing={2}
      >
        <IgShippingProgressBar
          threshold={3}
          configType={configType}
          progressBarWidget={widget as AnyProgressBarWidget}
        />
      </Grid>
    );
  }

  if (widgetType === "messageBoxPopup" || widgetType === "messageBoxSlideOut") {
    return (
      <Grid
        item
        container
        direction={"column"}
        sx={{ alignItems: "center" }}
        rowSpacing={2}
      >
        <IgDiscountMessageBox
          configType={configType}
          messageBoxWidget={widget as DiscountMessageBoxWidget}
        />
      </Grid>
    );
  }

  return null;
};
